// For redirecting Parent Support pages to Knowledge Base (aka Help Site)

/*
This file a list of all redirect links for Parent Support pages.
In Jan 2025, we introduced the Knowledge Base (https://help.beastacademy.com), and we want
our B2C customers to use that instead of the existing support pages
(/parent/support/{section}/{topic}) when they have questions.
*/

const KB_URLS = {
	MAIN: "https://help.beastacademy.com",
	BAO_QUICKSTART_GUIDE:
		"https://help.beastacademy.com/a/1891627-beast-academy-online-quickstart-guide",
	SETUP_STUDENT_ACCOUNT:
		"https://help.beastacademy.com/a/1798874-how-to-set-up-your-student-s-account",
	ACCOUNTS_OVERVIEW:
		"https://help.beastacademy.com/a/1889987-accounts-overview",
	SUBSCRIPTIONS_OVERVIEW:
		"https://help.beastacademy.com/a/1866695-subscriptions-overview",
	NAVIGATING_BAO:
		"https://help.beastacademy.com/a/1798920-navigating-beast-academy-online",
	LIBRARY_OVERVIEW: "https://help.beastacademy.com/a/1798921-library-overview",
	CLASS_OVERVIEW: "https://help.beastacademy.com/a/1798922-class-overview",
	THEATRE_OVERVIEW: "https://help.beastacademy.com/a/1798923-theater-overview",
	STUDENT_PROGRESS_AND_ACTIVITY_OVERVIEW:
		"https://help.beastacademy.com/a/1798926-student-progress-and-activity-overview",
	BEAST_BUILDER_AND_AVATAR_OVERVIEW:
		"https://help.beastacademy.com/a/1798927-beast-builder-and-avatar-overview",
	PARENT_REPORTING_OVERVIEW:
		"https://help.beastacademy.com/a/1793720-parent-reporting-overview",
	PLAY_SETTINGS_OVERVIEW:
		"https://help.beastacademy.com/a/1799492-play-settings-overview",
	SUBSCRIPTION_CANCELLATION_OVERVIEW:
		"https://help.beastacademy.com/a/1862092-subscription-cancellation-overview",
	SYSTEM_REQUIREMENTS:
		"https://help.beastacademy.com/a/1811899-system-requirements",
};

/*
In this nested object, the top-level properties correspond to the "section" param of the original url
while the child properties correspont to the "topic" param.
"root" corresponds to the redirect link when no topic is provided.
*/
const REDIRECT_LINKS = {
	getstarted: {
		root: KB_URLS.BAO_QUICKSTART_GUIDE,
		"parent-account-setup": KB_URLS.ACCOUNTS_OVERVIEW,
		"student-subscription-setup": KB_URLS.ACCOUNTS_OVERVIEW,
		"change-student-subscription": KB_URLS.SUBSCRIPTIONS_OVERVIEW,
		"sign-in-ba": KB_URLS.ACCOUNTS_OVERVIEW,
		"student-sign-in": KB_URLS.ACCOUNTS_OVERVIEW,
		"parent-sign-in": KB_URLS.ACCOUNTS_OVERVIEW,
	},
	play: {
		root: KB_URLS.NAVIGATING_BAO,
		"getting-around": KB_URLS.NAVIGATING_BAO,
		"home-screen": KB_URLS.NAVIGATING_BAO,
		"navigation-bar": KB_URLS.NAVIGATING_BAO,
		"play-list": KB_URLS.NAVIGATING_BAO,
		"learning-and-practice": KB_URLS.NAVIGATING_BAO,
		library: KB_URLS.LIBRARY_OVERVIEW,
		class: KB_URLS.CLASS_OVERVIEW,
		theater: KB_URLS.THEATRE_OVERVIEW,
		"puzzle-lab": KB_URLS.NAVIGATING_BAO,
		"tracking-progress": KB_URLS.STUDENT_PROGRESS_AND_ACTIVITY_OVERVIEW,
		profile: KB_URLS.STUDENT_PROGRESS_AND_ACTIVITY_OVERVIEW,
		beastbuilder: KB_URLS.BEAST_BUILDER_AND_AVATAR_OVERVIEW,
	},
	reports: {
		root: KB_URLS.PARENT_REPORTING_OVERVIEW,
		"my-students": KB_URLS.PARENT_REPORTING_OVERVIEW,
		"reading-the-reports": KB_URLS.PARENT_REPORTING_OVERVIEW,
		icons: KB_URLS.PARENT_REPORTING_OVERVIEW,
		navigation: KB_URLS.PARENT_REPORTING_OVERVIEW,
		"report-pages": KB_URLS.PARENT_REPORTING_OVERVIEW,
		progress: KB_URLS.PARENT_REPORTING_OVERVIEW,
		"ba-level-reports": KB_URLS.PARENT_REPORTING_OVERVIEW,
		"chapter-reports": KB_URLS.PARENT_REPORTING_OVERVIEW,
		"lesson-reports": KB_URLS.PARENT_REPORTING_OVERVIEW,
		"puzzle-lab-reports": KB_URLS.PARENT_REPORTING_OVERVIEW,
		activity: KB_URLS.PARENT_REPORTING_OVERVIEW,
		locks: KB_URLS.PLAY_SETTINGS_OVERVIEW,
	},
	account: {
		root: KB_URLS.SUBSCRIPTIONS_OVERVIEW,
		"my-account": KB_URLS.SUBSCRIPTIONS_OVERVIEW,
		"subscriptions-tab": KB_URLS.SUBSCRIPTIONS_OVERVIEW,
		"subscriptions-settings": KB_URLS.ACCOUNTS_OVERVIEW,
		"canceling-subscription": KB_URLS.SUBSCRIPTION_CANCELLATION_OVERVIEW,
		"upgrading-subscription": KB_URLS.SUBSCRIPTIONS_OVERVIEW,
		"changing-subscription": KB_URLS.SUBSCRIPTIONS_OVERVIEW,
		"renewing-subscription": KB_URLS.SUBSCRIPTIONS_OVERVIEW,
		"info-and-payments-tab": KB_URLS.ACCOUNTS_OVERVIEW,
	},
	planning: {
		root: "https://beastacademy.com/resources/planning",
		"chapter-overviews":
			"https://beastacademy.com/resources/planning/overviews",
		sequence: "https://beastacademy.com/resources/planning/sequence",
		standards: "https://beastacademy.com/resources/planning/standards",
		"placement-tests": "https://beastacademy.com/resources/placementtests",
	},
};

/*
Results of this function:
- If no section or topic is provided, this will provide base url to KB.
- If only section is provided and it exists in REDIRECT_LINKS, that link will be provided.
- If section is provided but it doesn't exist in REDIRECT_LINKS, this func returns null.
- If section is provided and exists, and topic is provided and it exists, returns corresponding link.
- If section is provided and exists, and topic is provided and does not exists, returns null
Based on this, use a null return value to mean we should not redirect. This can mean we take them to
the original support page (likely not, since they will be depecrated), or send them to the base url
*/
const getRedirectLink = function(section, topic) {
	if (!section) {
		return "https://help.beastacademy.com";
	}
	if (REDIRECT_LINKS[section]) {
		return REDIRECT_LINKS[section][topic] || REDIRECT_LINKS[section].root;
	}
};

module.exports = {
	KB_URLS,
	REDIRECT_LINKS,
	getRedirectLink,
};
